const generateUniqueId = () => (
  Math.floor(Math.random() * Date.now())
);

export default generateUniqueId;
